import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { fontSizeMap } from '../../../consts';
import { ButtonMenuItemComponent } from '../../../shared/components/button-menu-item/button-menu-item.component';
import { ContextMenuComponent } from '../../../shared/components/context-menu/context-menu.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { CapitalizePipe } from '../../../shared/pipes/capitalize.pipe';
import { AccessItemCtaComponent } from '../access-item-cta/access-item-cta.component';
import { AccessItemHeaderComponent } from '../access-item-header/access-item-header.component';
import { AccessItemComponent } from '../access-item/access-item.component';

@Component({
  selector: 'app-theme-font-size-item',
  imports: [
    AccessItemComponent,
    AccessItemHeaderComponent,
    AccessItemCtaComponent,
    ContextMenuComponent,
    ButtonDirective,
    SvgComponent,
    ButtonMenuItemComponent,
    CapitalizePipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './theme-font-size-item.component.html',
  styleUrl: './theme-font-size-item.component.scss',
})
export class ThemeFontSizeItemComponent {
  fontSize = input.required<number>();
  allowHuge = input<boolean>();
  fontSizeChange = output<number>();
  sizes = computed(() => {
    const allowHuge = this.allowHuge();
    return Object.keys(fontSizeMap)
      .map(key => ({ key, value: fontSizeMap[key] }))
      .filter(({ key }) => allowHuge || key !== 'huge');
  });

  displayedFontSize = computed(() => {
    const fontSize = this.fontSize();
    return Object.keys(fontSizeMap).find(key => fontSizeMap[key] === fontSize) || 'small';
  });
}
